import {
  EventsApi,
  LifeEventResponse,
  LifeEventListResponse,
  CreateLifeEventRequest,
  UpdateLifeEventRequest,
  AddLifeEventParticipantRequest
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped life events API with standardized error handling.
 * Uses the SDK (EventsApi); called only from PersonLifeEventsStore.
 */
class WrappedPersonLifeEventsApi {
  async listLifeEventsForPerson(familyMemberId: string): Promise<ApiResult<LifeEventListResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.listLifeEventsForPerson(familyMemberId)
    );
  }

  async createLifeEvent(body: CreateLifeEventRequest): Promise<ApiResult<LifeEventResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.createLifeEvent(body)
    );
  }

  async updateLifeEvent(lifeEventId: string, body: UpdateLifeEventRequest): Promise<ApiResult<LifeEventResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.updateLifeEvent(lifeEventId, body)
    );
  }

  async deleteLifeEvent(lifeEventId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.deleteLifeEvent(lifeEventId)
    );
  }

  async addParticipant(
    lifeEventId: string,
    body: AddLifeEventParticipantRequest
  ): Promise<ApiResult<LifeEventResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.addLifeEventParticipant(lifeEventId, body)
    );
  }

  async deleteParticipant(lifeEventId: string, familyMemberId: string): Promise<ApiResult<LifeEventResponse>> {
    return withApiSetup(
      (config) => new EventsApi(config),
      getApiConfiguration,
      (api) => api.deleteLifeEventParticipant(lifeEventId, familyMemberId)
    );
  }
}

export const personLifeEventsApi = new WrappedPersonLifeEventsApi();
export default personLifeEventsApi;

// Re-export SDK types for store/component use
export type {
  LifeEventResponse,
  LifeEventListResponse,
  CreateLifeEventRequest,
  UpdateLifeEventRequest,
  AddLifeEventParticipantRequest
} from 'we-tree-api-client/v2';
